import { useMutation, useQueryClient } from '@tanstack/react-query';

import { pauseTournamentRest } from '@/services/tournaments/tournaments-service';

const usePauseTournament = (
  tournamentId: string,
  tournamentUrl: string,
  { onSuccess }: { onSuccess?: () => void } = {},
) => {
  const queryClient = useQueryClient();

  const { mutateAsync: pauseTournament } = useMutation({
    mutationFn: () => {
      return pauseTournamentRest(tournamentUrl);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tournament', tournamentId] });
      onSuccess?.();
    },
  });

  return { pauseTournament };
};

export default usePauseTournament;
